// extracted by mini-css-extract-plugin
export var container = "_c9-1";
export var cornerButtonContainer = "_c9-6";
export var disabled = "_c9-2";
export var dragActive = "_c9-3";
export var fileContainer = "_c9-5";
export var hiddenInput = "_c9-4";
export var widthContainer = "_c9-0";